import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Card.scss';
var CardTypes = {
    WHITE: 'white',
    GRAY: 'gray',
    SHADOW: 'shadow',
    GENERAL: 'general',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
};
var Card = function (_a) {
    var children = _a.children, className = _a.className, isCentered = _a.isCentered, type = _a.type, props = __rest(_a, ["children", "className", "isCentered", "type"]);
    var cardClassName = classnames('Card', "Card--".concat(type), className, {
        'Card--isCentered': isCentered
    });
    return (React.createElement("div", __assign({}, props, { className: cardClassName }), children));
};
Card.defaultProps = {
    isCentered: true,
    onAnimationEnd: function () { },
    type: CardTypes.WHITE
};
Card.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isCentered: PropTypes.bool,
    onAnimationEnd: PropTypes.func,
    type: PropTypes.oneOf(Object.values(CardTypes))
};
export default Card;
//# sourceMappingURL=Card.js.map